/*=========================================================================================
  File Name: moduleUserActions.js
  Description: User Module Actions
  ----------------------------------------------------------------------------------------
==============================*/
import mailServerService from '@/services/mailServer.service.js'

export default {

  getMailServers({commit, dispatch}, params){
    return mailServerService.getMailServers(params)
      .then(response =>{
        commit('SET_MAIL_SERVERS', response.data.data)
      })
      .catch(error =>{
        dispatch("alertError", error, { root: true });
      })
  },
  getFullMailServers({commit, dispatch}, params){
    return mailServerService.getFullMailServers(params)
      .then(response =>{
        commit('SET_FULL_MAIL_SERVERS', response.data)
      })
      .catch(error =>{
        dispatch("alertError", error, { root: true });
      })
  },

  createMailServer({ dispatch }, params) {
    return mailServerService.createMailServer(params)
      .then(response => {
        dispatch('alertSuccess', typeof response.message == 'object' ? response.message[0]:response.message, { root: true })
        return Promise.resolve(response.data);
      })
      .catch(error =>{
          if(typeof error.errors == 'object' && Object.values(error.errors).length > 0){
              dispatch("alertError",Object.values(error.errors)[0][0], { root: true });
          }
          else dispatch("alertError",typeof error.message == 'object' ? error.message[0]:error.message, { root: true });
      })
  },

  updateMailServer({commit, dispatch}, data){
    return mailServerService.updateMailServer(data)
      .then(response => {
        dispatch("alertSuccess", typeof response.message == 'object' ? response.message[0]:response.message, { root: true })
        return Promise.resolve(response.data);
      })
      .catch(error => {
          if(typeof error.errors == 'object'){
              if(Object.values(error.errors).length > 0){
                  dispatch("alertError",Object.values(error.errors)[0][0], { root: true });
              }
          }
        else dispatch("alertError",typeof error.message == 'object' ? error.message[0]:error.message, { root: true });
      })
  },

  deleteMailServers({commit, dispatch}, ids){
    return mailServerService.deleteMailServers({cids: ids})
      .then(response => {
        dispatch("alertSuccess", typeof response.message == 'object' ? response.message[0]:response.message, { root: true })
      })
      .catch(error =>{
        if(typeof error.errors == 'object'){
          if(Object.values(error.errors).length > 0){
            dispatch("alertError",Object.values(error.errors)[0][0], { root: true });
          }
        }
        else dispatch("alertError",typeof error.message == 'object' ? error.message[0]:error.message, { root: true });
      })
  },

  fetchMails ({ commit, dispatch }, payload) {
    return mailServerService.getMailServers(payload)
      .then(response => {
        commit('SET_MAIL_SERVERS', response.data.data)
        commit('SET_INFO_DB', {totalPage: response.data.last_page, totalRow: response.data.total})
        return Promise.resolve(response.data.data)
      })
      .catch(error =>{
        if(Object.values(error.errors).length > 0){
          dispatch("alertError",Object.values(error.errors)[0][0], { root: true });
        }
        else dispatch("alertError",typeof error.message == 'object' ? error.message[0]:error.message, { root: true });
      })
  },
  fetchMail ({ commit, dispatch }, id) {
    return mailServerService.getMailServer(id)
      .then(response => {
        return Promise.resolve(response.data)
      })
      .catch(error =>{
        if(typeof error.errors == 'object'){
          if(Object.values(error.errors).length > 0){
            dispatch("alertError",Object.values(error.errors)[0][0], { root: true });
          }
        }
        else dispatch("alertError",typeof error.message == 'object' ? error.message[0]:error.message, { root: true });
      })
  },

  testConnection ({ commit, dispatch }, params) {
    return mailServerService.testConnection(params)
      .then(response => {
        if (response.data && response.data == true){
          return Promise.resolve(response.data);
        }
        else{
          return Promise.resolve(response.message);
        }
      })
      .catch(response =>{
         return Promise.resolve(response.message);

      })
  },
    
}